<!------------------------------------------------------------------------------
 File: BaseBadge 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 17/10/2018
 Time: 17:20
------------------------------------------------------------------------------->
<template>
    <div :class="{
        'd-flex justify-content-between align-items-center test':distribute == true
    }">
        <span
            v-if="title!=''"
            class="pr-1 pl-1"
        >{{title}}</span>
        <span
            class="badge badge-pill"
            :class="cls"
        >
            <slot></slot>
        </span>
    </div>
</template>

<script>
    export default {
        name: '',
        components: {},
        props: {
            distribute:{
                type:Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            cls: {
                type: Object | String,
                default: 'badge-primary'
            }
        },
        created() {},
        destroyed() {},
        mounted() {

        },
        data() {
            return {};
        },
        methods: {},
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/base/BaseBadge.vue?b4f0c212